'use client';

import { Link } from '@theme/components';
import { SpecialPageType } from '@akinon/next/types';
import { Image } from '@akinon/next/components/image';
export interface Props {
  data: SpecialPageType;
}

const SpecialPageBanner = (props: Props) => {
  if (!props.data?.banner) {
    return null;
  }

  return (
    <div className="mb-10 px-[5%] lg:px-0">
      <Link href={props.data?.banner_url || '#'}>
        <Image
          src={props.data?.banner_mobile}
          alt={props.data?.name}
          width={370}
          height={280}
          className="w-full max-h-[280px] aspect-[370/280] block md:hidden"
          imageClassName="h-full w-full object-cover"
        />

        <Image
          src={props.data?.banner}
          alt={props.data?.name}
          width={1680}
          height={620}
          className="w-full hidden md:block"
          imageClassName="h-full w-full object-cover"
        />
      </Link>
    </div>
  );
};

export default SpecialPageBanner;
